import { Button } from '@/components/ui/button'

interface AuthUnreachableProps {
  onRetry: () => void
}

/** Shown while a stored session can't be checked because Maxflow is unreachable. */
export function AuthUnreachable({ onRetry }: AuthUnreachableProps) {
  return (
    <div
      data-testid="auth-unreachable"
      className="bg-background flex h-screen w-screen flex-col items-center justify-center gap-6 px-4 text-center"
    >
      <img src="/assets/logo-static-dark.svg?v=3" alt="MaxFlow" className="h-12 w-auto" />
      <div className="flex flex-col items-center gap-2">
        <p className="text-foreground font-medium">Can't reach Maxflow</p>
        <p className="text-muted-foreground text-sm">
          Check your connection. You're still signed in, and we'll keep trying.
        </p>
      </div>
      <Button onClick={onRetry}>Try again</Button>
    </div>
  )
}
